import { render } from "./GoodsManagement.vue?vue&type=template&id=33b1e951&scoped=true"
import script from "./GoodsManagement.vue?vue&type=script&lang=js"
export * from "./GoodsManagement.vue?vue&type=script&lang=js"

import "./GoodsManagement.vue?vue&type=style&index=0&id=33b1e951&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-33b1e951"

export default script